import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { UserDto } from '@app/generated/model';

import { Subject, takeUntil } from 'rxjs';
import { getCurrentUser } from '@dwo/selectors';
import { Store } from '@ngrx/store';
import { MsalService } from '@azure/msal-angular';
import { ReleaseNoteService } from '@app/core/services/release-note.service';

@Component({
  selector: 'app-user',
  templateUrl: 'user.component.html',
  styleUrls: ['user.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class UserComponent implements OnInit {
  public user: UserDto;
  public usersFirstLetter: string;
  public isOpen = false;
  public currentVersion: string = '';
  private readonly destroy$ = new Subject<boolean>();

  constructor(
    private store: Store,
    private authService: MsalService,
    private releaseNoteService: ReleaseNoteService,
  ) {}

  ngOnInit(): void {
    this.store
      .select(getCurrentUser)
      .pipe(takeUntil(this.destroy$))
      .subscribe((user: UserDto) => {
        this.user = user;
        this.usersFirstLetter = this.user?.fullName?.charAt(0);
      });

    // Fetch current version
    this.releaseNoteService
      .checkVersionUpdate()
      .pipe(takeUntil(this.destroy$))
      .subscribe((versionCheck) => {
        this.currentVersion = versionCheck.currentVersion || '';
      });
  }

  clickOnUserInfo(event): void {
    event.stopPropagation();
  }

  signOut(): void {
    this.authService.logout();
  }
}
